<div class="w3-display-container w3-theme-primary auth-screen">
  <div class="w3-display-topmiddle w3-padding-48">
    <img [src]="logo" height="41px" [alt]="appName" />
  </div>
  <div class="w3-display-middle">
    @if (!showUpdatePassword) {
      <section class="w3-content login-form">
        <form (submit)="login($event, email.value, password.value)">
          <header class="w3-container">
            <h2 class="w3-xlarge">Login</h2>
          </header>
          <section
            class="w3-container w3-margin-bottom w3-margin-left w3-border-theme-secondary w3-bottombar half-line"
          ></section>
          <section class="w3-container">
            <label class="" for="login-email"><b>Email</b></label>
            <input
              #email
              id="login-email"
              [value]="user"
              name="user-name"
              class="w3-input w3-border w3-section"
              [ngClass]="{ invalid: !credentialsValid }"
              type="text"
            />
            <label class="" for="login-password"><b>Password</b></label>
            <input
              #password
              id="login-password"
              [value]="pass"
              name="user-password"
              class="w3-input w3-border w3-section"
              [ngClass]="{ invalid: !credentialsValid }"
              type="password"
            />
          </section>
          <footer class="w3-container">
            <button class="w3-btn w3-block w3-white w3-section text-bold">
              Sign In
            </button>
          </footer>
        </form>
      </section>
    }
    @if (showUpdatePassword) {
      <section class="w3-content password-form">
        <form
          (submit)="
            updatePassword($event, newPassword.value, verifyPassword.value)
          "
        >
          <header class="w3-container">
            <h2 class="w3-xlarge">Update Password</h2>
          </header>
          <section
            class="w3-container w3-margin-bottom w3-margin-left w3-border-theme-secondary w3-bottombar half-line"
          ></section>
          <section class="w3-container">
            <label class="" for="update-new-password"
              ><b>New Password</b></label
            >
            <input
              #newPassword
              id="update-new-password"
              name="new-password"
              class="w3-input w3-border w3-section"
              [ngClass]="{ invalid: !credentialsValid }"
              type="password"
            />
            <label class="" for="update-verify-password"><b>Password</b></label>
            <input
              #verifyPassword
              id="update-verify-password"
              name="verify-password"
              class="w3-input w3-border w3-section"
              [ngClass]="{ invalid: !credentialsValid }"
              type="password"
            />
          </section>
          <footer class="w3-container">
            <button class="w3-btn w3-block w3-white w3-section text-bold">
              Update Password
            </button>
          </footer>
        </form>
      </section>
    }
  </div>
</div>
